/**
 * The application's addresses, built in one place.
 *
 * Both modules link into each other's screens, and a path written out by hand
 * at every call site is a path nobody updates when the route moves: the Agent
 * still linked to `/e/…` a release after the brand pages moved to `/w/…`, and
 * sent people to `/home` and `/o/…`, which no route answers.
 */

/** Where a signed-in reader lands; the router sends it on to the account's first brand. */
export const ENTRY = "/";

/** A brand's workspace: the Analytics overview. */
export function brand(id: string): string {
	return `/w/${encodeURIComponent(id)}`;
}

/** The Agent module, or one of its screens (`agent(id, "logs")`). */
export function agent(id: string, sub?: string): string {
	const root = `${brand(id)}/agent`;
	return sub ? `${root}/${sub.replace(/^\/+/, "")}` : root;
}

/**
 * The settings page, open on a section when one is named.
 *
 * An empty id is an account with no brand yet: the page lives above the brand
 * then, showing the sections that are the account's and the person's own.
 */
export function settings(id: string, section?: string): string {
	const root = id ? `${brand(id)}/settings` : "/settings";
	return section ? `${root}/${section}` : root;
}
